var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useI18n } from 'vue-i18n';
import MediaService from '../services/MediaService';
import { useStore } from '../store';
import { copyToClipboard } from '../util/helper';
import useEmitter from './useEmitter';
import { useEvent } from './useEvent';
export default function useContextMenu() {
    const { sendNotification } = useEvent();
    const i18n = useI18n();
    const emitter = useEmitter();
    const store = useStore();
    function contextMenuItemClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const { item, option } = event;
            if (option.slug === 'link') {
                if (item.url) {
                    //Normal file
                    copyToClipboard(item.url);
                }
                else if (item.largeImageURL) {
                    //Pixabay file
                    copyToClipboard(item.largeImageURL);
                }
                else if (item.urls) {
                    //Unsplash file
                    copyToClipboard(item.urls.full);
                }
                sendNotification({
                    title: i18n.t('common.copiedClipboard'),
                    type: 'success',
                });
            }
            else if (option.slug === 'rename') {
                emitter.emit('renameObject', item);
            }
            else if (option.slug === 'delete') {
                try {
                    emitter.emit('deleteFileFolder', {
                        id: item._id,
                        type: item.type,
                        name: item.name,
                    });
                }
                catch (error) {
                    console.error(error);
                }
            }
            else if (option.slug === 'move') {
                emitter.emit('moveItem', item);
            }
            else if (option.slug === 'addPixabayImage') {
                const params = {
                    altId: store.altId,
                    altType: store.altType,
                    url: item.largeImageURL,
                    previewUrl: item.previewURL,
                    source: 'pixabay',
                };
                try {
                    yield MediaService.addFile(params);
                    sendNotification({
                        title: i18n.t('common.successfullyAdded'),
                        type: 'success',
                    });
                    emitter.emit('updateUI', item);
                }
                catch (error) {
                    sendNotification({
                        title: i18n.t('common.failedToAddMedia'),
                        type: 'error',
                    });
                }
            }
            else if (option.slug === 'addUnsplashImage') {
                const params = {
                    altId: store.altId,
                    altType: store.altType,
                    url: item.urls.full,
                    source: 'unsplash',
                };
                try {
                    yield MediaService.addFile(params);
                    sendNotification({
                        title: i18n.t('common.successfullyAdded'),
                        type: 'success',
                    });
                    emitter.emit('updateUI', item);
                }
                catch (error) {
                    sendNotification({
                        title: i18n.t('common.failedToAddMedia'),
                        type: 'error',
                    });
                }
            }
        });
    }
    return { contextMenuItemClick };
}
